// extracted by mini-css-extract-plugin
module.exports = {"container":"ControlPanel_container__3V8Kz","mute_button":"ControlPanel_mute_button__31F3s"};